import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import giftCardImg from "@/assets/gift-card.png";

const GiftCardProductCard = () => {
  return (
    <div className="group rounded-xl shadow-sm hover:shadow-lg transition-all overflow-hidden h-full flex flex-col border-[3px] border-[hsl(120,100%,40%)] relative">
      {/* Badge */}
      <div className="absolute top-2 right-2 z-20 bg-[hsl(120,100%,40%)] text-black text-[10px] font-extrabold px-2 py-1 rounded-md shadow-md uppercase tracking-wider animate-pulse">
        🎁 Dāvanu ideja!
      </div>

      <Link to="/gift-card">
        <div className="aspect-square bg-card flex items-center justify-center overflow-hidden relative w-full">
          <img
            src={giftCardImg}
            alt="Padel Corner Dāvanu Karte"
            width={400}
            height={400}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="p-3 md:p-4 flex flex-col flex-1 bg-card">
        <Link to="/gift-card" className="flex-1 min-h-0">
          <p className="text-xs text-muted-foreground mb-1">Padel Corner</p>
          <h3 className="font-display font-semibold text-sm md:text-base leading-tight mb-2 group-hover:text-primary transition-colors line-clamp-2">
            Dāvanu karte
          </h3>
        </Link>
        <div className="mt-auto">
          <div className="flex items-baseline gap-2 mb-3">
            <span className="font-display font-bold text-price">No €30</span>
          </div>
          <Button size="sm" className="w-full gap-2 font-display" asChild>
            <Link to="/gift-card">
              <Gift size={14} /> Izvēlēties summu
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GiftCardProductCard;
